module.exports = __webpack_public_path__ + "static/media/WowDigital.7a27ba79.ico";